module.exports = __webpack_public_path__ + "static/media/flip_camera_btn_white.e6c09843.png";